export function formatApiErrorForUi(error: unknown): string {
  if (!error) return "Unbekannter Fehler";

  if (typeof error === "string") return error;

  if (error instanceof Error) {
    // ApiError carries the function's own response body. Read it through a narrow shape rather
    // than `any`: the only extra field wanted here is serverMessage, and naming it turns a typo
    // into a compile error instead of a silent fall-through to Error.message.
    const withServerMessage = error as Error & { serverMessage?: unknown };

    // Prefer serverMessage from ApiError if provided (exact Function body)
    if (typeof withServerMessage.serverMessage === "string" && withServerMessage.serverMessage.trim()) {
      return withServerMessage.serverMessage;
    }

    // Fall back to Error.message
    if (error.message) return error.message;
  }

  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}
